<template>
    <div>
        <nav class="navbar is-warning" role="navigation">
            <div class="container">
                <span class="tag has-text-weight-semibold is-warning">Наши телефоны:</span>
                <span class="tag has-text-weight-bold" @click="prompt"><a href="tel:+998997950471">+998 99 795 04 71</a></span>
                <span class="tag has-text-weight-bold"><a href="tel:+998997950472">+998 99 795 04 72</a></span>
                <span class="tag has-text-weight-bold"><a href="tel:+998997950473">+998 99 795 04 73</a></span>
                <span class="tag has-text-weight-bold"><a href="tel:+998997950475">+998 99 795 04 75</a></span>
                <span class="tag has-text-weight-bold"><a href="tel:+998997950476">+998 99 795 04 76</a></span>
            </div>
        </nav>
    </div>
</template>

<script>

    export default {
        name: "TopBar",

        methods: {
            prompt() {
                this.$dialog.prompt({
                    message: `What's your name?`,
                    inputAttrs: {
                        placeholder: 'e.g. Walter',
                        maxlength: 10
                    },
                    onConfirm: (value) => this.$toast.open(`Your name is: ${value}`)
                })
            },
        }
    }
</script>
<style scoped>
    .tag {
        width: 45%;
    }
</style>